<template>
  <div class="alert-bg">
    <div class="alert">
      <div class="alert-header">
        <div class="alert-title" v-html="title"></div>
        <div class="alert-btn" @click="confirmFunc"></div>
      </div>
      <div class="alert-content">
        <div class="data" v-html="data"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'analysisAlertTemplate',
    props: ['confirm', 'title', 'data', 'userDevice'],
    mounted() {
      if (this.userDevice === 'mobile') {
        const RESIZE = () => {
          const WRAPPER = document.querySelector('.alert');
          if (Math.abs(window.orientation) === 90) {
            WRAPPER.style.width = window.innerWidth * 0.5 + 'px';
            WRAPPER.style.marginLeft = -(window.innerWidth * 0.5 / 2) + 'px';
            WRAPPER.style.height = window.innerHeight * 0.6 + 'px';
            WRAPPER.style.marginTop = -(window.innerHeight * 0.6 / 2) + 'px';
          } else {
            WRAPPER.style.width = window.innerWidth * 0.7 + 'px';
            WRAPPER.style.marginLeft = -(window.innerWidth * 0.7 / 2) + 'px';
            WRAPPER.style.height = window.innerHeight * 0.3 + 'px';
            WRAPPER.style.marginTop = -(window.innerHeight * 0.3 / 2) + 'px';
          }
        };
        RESIZE();
        window.addEventListener('resize', RESIZE);
      }
    },
    methods: {
      confirmFunc() {
        this.$emit('close');
        if (typeof this.confirm === 'function')
          this.confirm();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .alert-bg{
    width:100%;
    height:100%;
    background-color: rgba(0, 0, 0, 0.35);
    position: absolute; top: 0; right: 0; bottom: 0; left: 0;
    overflow: hidden;
    position: fixed;
  }
  .alert {
    /*display:table;*/
    position: fixed;
    z-index: 4;
    left: 50%;
    top: 50%;
    margin-left: -340px;
    margin-top: -125px;
    width: 680px;
    height: 250px;
    //border: 0px solid #58b3a1;
    border-radius: 20px !important;
    background-color: #ffffff;


    .alert-header{
      width:100%;
      height:88px;
      border-top-left-radius: 20px !important;
      border-top-right-radius: 20px !important;
      background-color: #6bc1b2;
      //background-color: #ffffff;

      .alert-title {
        /*width: 216px;*/
        // width:585px;
        // height: 25px;
        // float:left;
        /*border: 1px solid red;*/
        font-family: 'NanumSquareRoundEB', sans-serif;
        font-size: 25px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: -1.3px;
        text-align: center;
        color: #ffffff;
        vertical-align: middle;
        // margin-top:36px;
        display: inline-block;
        padding-top:28px;
        padding-left:40px;
        /*margin-left:235px;*/
        /*margin-left:auto;*/
        /*margin-right:auto;*/
      }
      .alert-btn {
        cursor: pointer;
        float:right;
        background: url("../../assets/images/analysis/alert_exit.png") no-repeat;
        width: 47px;
        height: 47px;
        line-height: 35px;
        //border-radius: 20px;
        margin-top: 24px;
        margin-right: 18px;
      }
    }

    .alert-content {
      background-color: #00000000;
      /*display:table-row;*/
      width:100%;
      height:162px;
      border: 0px solid gray;

      .data{
        width:560px;
        /*border: 1px solid red;*/
        font-family: 'NanumSquareRoundR', sans-serif;
        font-size: 22px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.82;
        letter-spacing: -1.1px;
        text-align: left;
        color: #000000;
        border-radius: 2px !important;
        // position: absolute;
        // top: 50%;
        // left: 50%;
        // margin-top:0px;
        // margin-left:-280px;
        margin: 0 auto;
        padding-left: 40px;
        padding-top: 35px;
        vertical-align: middle;
        word-break: keep-all;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/AnalysisModal.vue